export default __webpack_public_path__ + "static/media/DC2.878a0abf.svg";